import { useRequiredParams } from '@dealstack/frontend/shared/utils/useRequiredParams.ts';
import { usePermissionRequest } from '@dealstack/frontend/shared/components/PermissionWrapper/PermissionWrapper.tsx';
import { PermissionRole, ResourceType } from '@dealstack/shared/lib/generated';

export const useInvestmentsPermissions = () => {
	const { mipId } = useRequiredParams('mipId');

	const { hasPermission: hasEditorPermission } = usePermissionRequest({
		resourceType: ResourceType.PROGRAMME,
		resourceId: mipId,
		permissionRole: PermissionRole.EDITOR,
	});

	const { hasPermission: hasKycAdminPermission } = usePermissionRequest({
		resourceType: ResourceType.PROGRAMME,
		resourceId: mipId,
		permissionRole: PermissionRole.KYC_ADMIN,
	});

	return { hasEditorPermission, hasKycAdminPermission };
};
